// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1994":"c87eecd4b686fbfd","6588":"e957677aa95ab873","9924":"1495ce335013c7ce"}[chunkId] + ".css";
};